import dayjs from "dayjs";

export const format = (date = null, formatString = "DD/MM/YYYY") =>
  date ? dayjs(date).format(formatString) : "";

export const toDate = (date = null) => dayjs(date).toDate();
